'use strict';
import {MediaQueries} from "../../../infra/mediaQueries.service";
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';

var angular: angular.IAngularStatic = require('angular');
import {Component, Inject} from 'ng-metadata/core';
import {getAttributesMap, getVid} from '../../../appConfig/appConfigForward';
import {PrimolyticsService, beacon} from '../../../analytics/primolytics.service';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {SearchFieldsService} from '../../search.fields.service';
import {JournalsService} from "../../../journals/journals.service";
import {StorageUtil} from "../../../infra/storageUtil.service";
import {BriefResultService} from "../../briefResult/briefResult.service";
import {QrCodeService} from "../qrCode/qrCode.service";
import { FavoritesWarningMessageService } from "../../../favorites/favoritesWarningMessage/favoritesWarningMessage.service";
import {AnalyticsUtils} from "../../../../components/nddUtils/analyticsUtils.service";

const clone = require('lodash/clone');
const throttle = require('lodash/throttle');

@Component({
    selector: 'prm-search-bookmark-filter',
    templateUrl: 'components/search/topbar/bookmarkFilter/search-bookmark-filter.html',
})


export class PrmSearchBookmarkFilter {


    private view = getVid();
    private scroll;
    private FAVORITES_STATE = STATE_NAMES.FAVORITES;
    private SEARCH_STATE = STATE_NAMES.SEARCH;
    private handler = throttle(() => this.handlerUnbound(), 100);
    public searchMethod: string;

    constructor(@Inject('topBarIcons') private topBarIcons,
                @Inject('actionIcons') private  actionIcons: Object,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                private primolyticsService: PrimolyticsService,
                @Inject('backToTopIcon') private backToTopIcon,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$window') private $window: ng.IWindowService,
                private searchFieldsService: SearchFieldsService,
                private journalsService: JournalsService,
                private storageUtil: StorageUtil,
                private mediaQueries: MediaQueries,
                private briefResultService: BriefResultService,
                private favoritesWarningMessageService: FavoritesWarningMessageService,
                private qrCodeService: QrCodeService,
                private configurationUtil: ConfigurationUtil,
                private analyticsUtils: AnalyticsUtils,
    ) {

        this.scroll = 0;
        let windowEl = angular.element($window);
        windowEl.on('scroll', () => this.handler());
    }

    handlerUnbound() {
        this.scroll = window.pageYOffset;
        this.$scope.$digest();
    }

    get isFavorites() {
        return this.$state.is(STATE_NAMES.FAVORITES);
    }


    private backToTop() {
        let scrollStep = -window.pageYOffset / 2;
        let scrollInterval = setInterval(function () {
            if (window.pageYOffset && window.pageYOffset != 0) {
                window.scrollBy(0, scrollStep);
            } else clearInterval(scrollInterval);
        }, 15);
    }

    private fixedToTop() {
        if (this.scroll > 60 && (this.$state.is(STATE_NAMES.FAVORITES) || this.$state.is(STATE_NAMES.SEARCH) || this.$state.is(STATE_NAMES.JOURNAL_SEARCH) || this.$state.is(STATE_NAMES.COLLECTION_DISCOVERY))) {
            return true;
        }
        return false;
    }

    @beacon({'p': 'general', 'op': 'gotoeShelf'})
    goToFavorties() {
        //even though this function does nothing we leave it because of the beacon annotation
    }

    @beacon({'p': 'general', 'op': 'gotoSearch'})
    goToSearch() {
        //even though this function does nothing we leave it because of the beacon annotation   
    }

    @beacon({'p': 'general', 'op': 'gotoSearchHistory'})
    goToSearchHistory() {
        //even though this function does nothing we leave it because of the beacon annotation   
    }

    get favoritesStateParams() {
        return {vid: this.view, lang: this.$translate.use()};
    }

    get searchHistoryParams() {
        return {vid: this.view, lang: this.$translate.use(), section: 'search_history'};
    }

    get searchStateParams() {
        return this.searchFieldsService.searchParams;
    }

    get uiState() {
        this.detectSearchMethod();
        if (this.searchMethod === 'dbsearch') {
            return STATE_NAMES.DB_SEARCH;
        }
        if (this.searchMethod === 'jsearch') {
            return STATE_NAMES.JOURNAL_SEARCH;
        }
        return STATE_NAMES.SEARCH;
    }

    public showSearchHistoryTab() {
        return this.storageUtil.isLocalStorageAvailable; //if we are in cookie mode search history is disabled
    }

    get facetToLeft() {
        let viewConfig = getAttributesMap();
        return viewConfig['selectedFacetLocation'] === 'left';
    }

    public isToolBareEnable() {
        return this.briefResultService.enableOrDisableToolBar;
    }

    get showQrCodeButton() {
        return this.qrCodeService.showQrCodeButton();
    }

    public openQrDialogForUrl() {
        this.qrCodeService.openQrDialogForUrl();
    }

    public isFavoritesWarning() {
        return this.favoritesWarningMessageService.isDisplayFavoritesWarning();
    }

    get isRapidoSAEnabled(){
        return this.configurationUtil.getRapidoSAEnabled()
    }

    public isDiscoveryLocalNoLogin() {
        return this.configurationUtil.getDiscoveryLocalNoLogin();
    }
    
    public isDiscoveryServicePage() {
        return this.configurationUtil.getDiscoveryServicesPage();
    }

    public isDiscoveryWithExternalNoLogin() {
        return this.configurationUtil.getDiscoveryWithExternalNoLogin();
    }

    public sendAnalytics() {
        let payload = this.getAnalyticsPayload();
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.USER_MENU_LINKS, payload);
    }
    private getAnalyticsPayload(){
        return {
            'User Menu Link Name' : 'favorites'
        }
    }
    private detectSearchMethod() {
        const currentUrl = window.location.href;
        if (currentUrl.includes('/jsearch')) {
            this.searchMethod = 'jsearch';
        } else if (currentUrl.includes('/dbsearch')) {
            this.searchMethod = 'dbsearch';
        } else if (currentUrl.includes('/search')) {
            this.searchMethod = 'search';
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/bookmarkFilter/searchBookmarkFilter.directive.ts